import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//views
import Login from "./routes/Login";
import Profile from "./routes/Profile";
import UserRegister from "./routes/UserRegister";
import Main from "./views/Main";
import { PublisherDetails } from "./views/PublisherDetails";

//style
import "../src/stylesheets/index.css";
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/:town" element={<Main />} />
        <Route path="/login" element={<Login />} />
        <Route path="/user-register" element={<UserRegister />} />
        <Route path="u/:username" element={<Profile />} />
        <Route path="/:town/:category/:route" element={<PublisherDetails />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
